module.exports = __webpack_public_path__ + "img/073448.1c5fc2aa.png";